// Signing in through ICE (S4): a popup to /auth/ice/start, which goes on to ICE's sign-in and
// Microsoft, and ends on a page that posts back the same answer /auth/microsoft gives — the
// session is already set by then, or a company has to be chosen, or an error to show.
//
// Only a message from this app's own origin, in that shape, is listened to.
//
// On a phone the whole page goes instead (lib/signinPage.js), and the answer comes back on
// the address.

import { leavingToSignIn } from './signinPage.js'

const POPUP = 'width=520,height=640'

/** The answer the popup or the address carried: resolved as it is, or thrown if it's an error. */
export function settleIceAnswer(result) {
  if (result?.error) {
    const err = new Error(result.error.message)
    err.code = result.error.code
    throw err
  }
  return result
}

export function signInWithIce() {
  return new Promise((resolve, reject) => {
    const popup = window.open('/auth/ice/start', 'crew-dispatch-service-signin', POPUP)
    if (!popup) {
      reject(new Error('The sign-in window was blocked. Allow pop-ups for this site and try again.'))
      return
    }
    const done = (fn, value) => {
      window.removeEventListener('message', onMessage)
      clearInterval(closed)
      fn(value)
    }
    function onMessage(e) {
      if (e.origin !== window.location.origin || e.data?.type !== 'crew-dispatch-service-signin') return
      try {
        done(resolve, settleIceAnswer(e.data.result))
      } catch (err) {
        done(reject, err)
      }
    }
    window.addEventListener('message', onMessage)
    // Closed without an answer: the person shut it.
    const closed = setInterval(() => {
      if (popup.closed) done(reject, new Error('Sign-in was cancelled.'))
    }, 500)
  })
}

/** Sends this page through ICE's sign-in. It comes back to the app with the answer on the address. */
export function leaveForIce() {
  leavingToSignIn('ice')
  window.location.assign('/auth/ice/start?page=1')
}
